module.exports = __webpack_public_path__ + "static/media/2DR.abf00857.png";